import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['otherButton', 'otherSelect', 'otherField'];

  connect() {
    this.changeHandler();
  }

  changeHandler() {
    if (this.hasOtherButtonTarget) {
      this.checkOtherButton();
    } else if (this.hasOtherSelectTarget) {
      this.checkOtherSelect();
    }
  }

  checkOtherButton() {
    if (this.otherButtonTarget.checked) {
      this.showField();
    } else {
      this.hideField();
    }
  }

  checkOtherSelect() {
    if (['other', 'その他'].includes(this.otherSelectTarget.value)) {
      this.showField();
    } else {
      this.hideField();
    }
  }

  showField() {
    this.otherFieldTarget.classList.remove('hidden');
  }

  hideField() {
    this.otherFieldTarget.classList.add('hidden');
  }
}
